import { CharacterController } from "./character_controller";

export class SyncedCharacterController extends CharacterController {

    constructor() {
        super();
    }
}